import React from 'react';
import Grid2, {Grid2Props} from '@mui/material/Grid2';

function GridRoot({children, spacing = 2, ...gridRootProps}: Grid2Props) {
	return (
		<Grid2 container spacing={spacing} {...gridRootProps}>
			{children}
		</Grid2>
	);
}

function GridItem({
	children,
	xs,
	sm,
	md,
	lg,
	xl,
	...gridItemProps
}: Omit<Grid2Props, 'size'> & {xs?: number; sm?: number; md?: number; lg?: number; xl?: number}) {
	const sizeProps: {xs?: number; sm?: number; md?: number; lg?: number; xl?: number} = {};

	if (xs !== undefined) sizeProps.xs = xs;
	if (sm !== undefined) sizeProps.sm = sm;
	if (md !== undefined) sizeProps.md = md;
	if (lg !== undefined) sizeProps.lg = lg;
	if (xl !== undefined) sizeProps.xl = xl;

	if (
		xs === undefined &&
		(sm !== undefined || md !== undefined || lg !== undefined || xl !== undefined)
	) {
		sizeProps.xs = 12;
	}

	const finalSize = Object.keys(sizeProps).length > 0 ? sizeProps : undefined;

	return (
		<Grid2 size={finalSize} {...gridItemProps}>
			{children}
		</Grid2>
	);
}

export const StyledGrid = {
	Root: GridRoot,
	Item: GridItem,
};
